var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-4 col-md-8 dashboard-item"},[_c('div',{staticClass:"card bg"},[_c('apexchart',{staticClass:"apex-charts",attrs:{"dir":"ltr","series":_vm.series,"options":_vm.chartOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }